import {
  DashboardMenuItems,
  DashboardViewServiceInterface,
  DashboardGroupsMenuItems,
  DashboardRegisterRequestsType,
} from '@ckmk/angular';
import { environment } from '@app/src/environments/environment';
import {
  faBoxOpen,
  faHandshakeAngle,
  faLightbulb,
  faNewspaper,
} from '@fortawesome/free-solid-svg-icons';

export class DashboardViewService implements DashboardViewServiceInterface {
  public getSiteName(): string {
    return environment.SITE_NAME;
  }

  public getLogo(): string {
    return '/img/new_logo.jpeg';
  }

  public generalNavItems(): DashboardMenuItems | Promise<DashboardMenuItems> {
    return [];
  }

  public itemsNavItems(): DashboardMenuItems | Promise<DashboardMenuItems> {
    return [];
  }

  public settingsNavItems(): DashboardMenuItems | Promise<DashboardMenuItems> {
    return [];
  }

  public groupNavItems():
    | DashboardGroupsMenuItems
    | Promise<DashboardGroupsMenuItems> {
    return [
      {
        name: 'post',
        label: 'Posts',
        children: [
          {
            name: 'post-categories',
            label: 'Categories',
            path: 'posts/categories/list',
            icon: faBoxOpen,
            guard: {
              permissions: ['PERMISSION_READ_POST_CATEGORY'],
            },
            activeIfUrlInclude: '/posts/categories/',
          },
          {
            name: 'posts',
            label: 'Posts',
            path: 'posts/list',
            icon: faNewspaper,
            guard: {
              permissions: ['PERMISSION_READ_POST'],
            },
            activeIfUrlInclude: /\/posts\/(?!categories)/i,
          },
        ],
      },
      {
        name: 'solution',
        label: 'Solutions',
        children: [
          {
            name: 'solution-categories',
            label: 'Categories',
            path: 'solutions/categories/list',
            icon: faBoxOpen,
            guard: {
              permissions: ['PERMISSION_READ_SOLUTION_CATEGORY'],
            },
            activeIfUrlInclude: '/solutions/categories/',
          },
          {
            name: 'solutions',
            label: 'Solutions',
            path: 'solutions/list',
            icon: faLightbulb,
            guard: {
              permissions: ['PERMISSION_READ_SOLUTION'],
            },
            activeIfUrlInclude: /\/solutions\/(?!categories)/i,
          },
        ],
      },
      {
        name: 'service',
        label: 'Services',
        children: [
          {
            name: 'service-categories',
            label: 'Categories',
            path: 'services/categories/list',
            icon: faBoxOpen,
            guard: {
              permissions: ['PERMISSION_READ_SERVICE_CATEGORY'],
            },
            activeIfUrlInclude: '/services/categories/',
          },
          {
            name: 'services',
            label: 'Services',
            path: 'services/list',
            icon: faHandshakeAngle,
            guard: {
              permissions: ['PERMISSION_READ_SERVICE'],
            },
            activeIfUrlInclude: /\/services\/(?!categories)/i,
          },
        ],
      },
    ];
  }

  public async getSubscribes(): Promise<DashboardRegisterRequestsType> {
    return [];
  }
}
